import { ORDER_REVIEW as FEATURE_PREFIX } from 'featurePrefix.ids'

const ORDER_OVERVIEW_PREFIX = 'order-review-overview'
const ORDER_ADDRESSES_PREFIX = 'order-review-addresses'
const ORDER_DETAILS_PREFIX = 'order-review-details'
const CONTACTS_PREFIX = 'order-review-contacts'
const FINANCIAL_SUMMARY_PREFIX = 'financial-summary'
const STATUS_DROPDOWN_PREFIX = 'order-review-status-dropdown'
const ORDER_PAY_TAB_PREFIX = 'order-review-pay-tab'

export const ReviewPageIds = {
  AddProductsId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__add-products-button`,
  ShareId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__share-button`,
  CommentsId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__comments-button`,
  SendPaymentId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__send-payment-button`,
  DownloadId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__download-button`,
  VisualAssortmentId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__visual-assessment-button`,
  CommentsEditId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__comments-edit-button`,
  CommentsSaveId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__comments-save-button`,
  DownloadsPdfId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__downloads-order-summary-pdf-selector`,
  DownloadsExcelId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__downloads-order-summary-excel-selector`,
  DownloadsLinesheetId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__export-linesheet-to-size-selector`,
  DownloadsInvoiceId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__downloads-download-invoice-selector`,
  DownloadsButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__downloads-download-button`,
  ProductsEditButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__products-edit-button`,
  ShipAndBillEditButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__shipping-billing-edit-button`,
  ContactsEditButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__contacts-edit-button`,
  OrderDetailsEditButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__order-details-edit-button`,
  PriceChangesEditButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__price-changes-edit-button`,
  InternalNotesInputId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__internal-notes-input`,
  AssignRetailerButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__assign-retailer-button`,
  RevokeTermButtonId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__revoke-term-button`,
  OrderReferenceInputId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__order-reference-input`,
  PriceTypeDropdownId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__price-type-dropdown`,
  StatusDropdownButton: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__status-dropdown-button`,
  ShopifySyncActionId: `${FEATURE_PREFIX}__${ORDER_OVERVIEW_PREFIX}__shopify-sync-action`,
}

export const AddressReviewPageIds = {
  CreateAddressButtonShippingId: `${FEATURE_PREFIX}__${ORDER_ADDRESSES_PREFIX}__create-address-button-shipping`,
  CreateAddressButtonBillingId: `${FEATURE_PREFIX}__${ORDER_ADDRESSES_PREFIX}__create-address-button-billing`,
  SameAddressForShippingId: `${FEATURE_PREFIX}__${ORDER_ADDRESSES_PREFIX}__same-address-for-shipping`,
  SameAddressForBillingId: `${FEATURE_PREFIX}__${ORDER_ADDRESSES_PREFIX}__same-address-for-billing`,
}

export const ContactsIds = {
  SalesRepDropdownId: `${FEATURE_PREFIX}__${CONTACTS_PREFIX}__sales-rep-dropdown`,
  CreateNewButtonId: `${FEATURE_PREFIX}__${CONTACTS_PREFIX}__create-new-button`,
}

export const OrderDetailsIds = {
  CreatedDateId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-created-date`,
  LinesheetsId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-linesheets`,
  WarehouseId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-warehouse`,
  SeasonNameId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-season-name`,
  SeasonCodeId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-season-code`,
  YearId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-year`,
  DivisionId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-division`,
  OrderDeliveryWindowStartId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-order-delivery-window-start`,
  OrderDeliveryWindowEndId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-order-delivery-window-end`,
  ShippingDeliveryWindowStartId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-shipping-delivery-window-start`,
  ShippingDeliveryWindowEndId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-shipping-delivery-window-end`,
  EventId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-event`,
  OrderTypeId: `${FEATURE_PREFIX}__${ORDER_DETAILS_PREFIX}__form-order-type`,
}

export const FinancialSummaryIds = {
  EditButtonId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__edit-button`,
  SaveButtonId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__save-button`,
  OrderDiscountPercentId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__order-discount-percent`,
  OrderDiscountValueId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__order-discount-value`,
  AddCustomFeesButtonId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__add-custom-fees-button`,
  OrderCustomFeePercentId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__order-custom-fee-percent`,
  OrderCustomFeeValueId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__order-custom-fee-value`,
  TaxPercentId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__tax-percent`,
  TaxValueId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__tax-value`,
  UnlockFieldsId: `${FEATURE_PREFIX}__${FINANCIAL_SUMMARY_PREFIX}__order-unlock-fields`,
}

export const StatusDropdownIds = {
  Approve: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__approve`,
  SetToPending: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__pending`,
  SetToNotes: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__notes`,
  MarkAsShipped: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__shipped`,
  CancelOrder: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__cancel`,
  DuplicateOrder: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__duplicate`,
  Share: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__share`,
  SubmitForApproval: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__approval`,
  EditOrder: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__edit`,
  RequestPayment: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__request-payment`,
  PayNow: `${FEATURE_PREFIX}__${STATUS_DROPDOWN_PREFIX}__pay-now`,
}

export const PayTabIds = {
  RetailerInterestedId: `${FEATURE_PREFIX}__${ORDER_PAY_TAB_PREFIX}__retailer-interested-button`,
}

/*
 * Test ids live here rather than in orderReview.tsx so that <Header> — which
 * needs OrderHeaderDetails — does not have to import the page module. That
 * import made the page a transitive dependency of every Header test, pulling in
 * the whole page module graph with it.
 */
export const REVIEW_PAGE_TEST_IDS = {
  DownloadToggle: 'download-toggle',
  MessagesToggle: 'messages-toggle',
  ShareToggle: 'share-toggle',
  OrderHeader: 'order-header',
  OrderHeaderDetails: 'order-header-details',
} as const
